import bugsnagReact from '@bugsnag/plugin-react'
import React from 'react'

import bugsnagClient from '../../configuration/bugsnag'
import { chainDecorators, memoized } from '../../utils/ReactUtils'


const decorators = [
  memoized,
]

const setupBugsnag = (client) => {
  client.use(bugsnagReact, React)
  return client.getPlugin('react')
}

const BugsnagWrapperInstance = bugsnagClient
  ? setupBugsnag(bugsnagClient)
  : React.Fragment

const BugsnagWrapper = chainDecorators(decorators, BugsnagWrapperInstance)

export default BugsnagWrapper
